import * as Utils from './index';
import * as appStore from '../store/app/index';
import { CAST_STATE } from '../constants';

class CastSender {
  constructor(ctrl, config) {
    this.ctrl = ctrl;
    this.session = ctrl.session;
    this.store = ctrl.store;
    this.namespace = config.namespace;
    this.receiverAppId = config.receiverAppId;
    this.castState = null;
    this.lastBgPosition = 0;
    this.castMessageEventBinded = false;
    this.firstPingReceived = false;
  }
  bootstrap(callback) {
    const ctx = this;
    ctx.bootstrapCallback = callback;
    window['__onGCastApiAvailable'] = function (isAvailable) {
      if (isAvailable) {
        ctx.initializeCastPlayer();
        callback();
      }
    };
    this.loadSenderJs();
  }
  loadSenderJs() {
    const ctx = this;
    if (typeof window.cast === 'undefined') {
      Utils.loadJs('https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1')
        .then(function () {
          ctx.isJsLoaded = true;
        })
        .catch(function () {
          ctx.isJsLoaded = false;
        });
    } else {
      ctx.isJsLoaded = true;
    }
  }
  async sendBgImage() {
    if (!this.bgData) {
      this.bgData = await this.getBgImageData();
    }
    if (this.bgData) {
      var maxLength = 32 * 1000;
      var data = this.bgData.substr(this.lastBgPosition, maxLength);
      this.lastBgPosition = this.lastBgPosition + data.length;
      if (data) {
        this.sendMessage({
          action: 'BG_IMAGE',
          data: {
            totalSize: this.bgData.length,
            lastBgPosition: this.lastBgPosition,
            chunk: data,
          },
        });
      }
    }
  }
  getBgImageData() {
    return new Promise((resolve) => {
      const { app } = this.store.getState();
      if (app?.poster) {
        Utils.toDataURL(app.poster, (dataUrl) => {
          resolve(dataUrl);
        });
        return;
      }
      resolve(null);
    });
  }
  async onReceiverReady() {
    const store = this.store.getState();
    let localStoredSid;
    try {
      localStoredSid = localStorage.getItem(`auth_${store.app.eventId}_${store.app.config.wtData.userID}`);
    } catch (err) {
      localStoredSid = null;
    }
    this.store.dispatch(appStore.setCastVideoStarted(false));
    this.sendMessage({
      action: 'LOAD',
      config: {
        eventId: store.app.eventId,
        jwt: store.app.config.jwt,
        debug: store.app.config.debug,
        sid: localStoredSid,
        apiJsonKey: store.app.config.apiJsonKey,
      },
    });
  }
  onCastVideoStarted() {
    console.log('CAST VIDEO STARTED');
    this.store.dispatch(appStore.setCastVideoStarted(true));
    this.store.dispatch(appStore.setCastState(CAST_STATE.CONNECTED));
  }
  onReceiverMessages(namespace, data) {
    // console.log("Receiver Message", data);
    if (namespace === this.namespace && data) {
      let messageData;
      try {
        messageData = JSON.parse(data);
      } catch (e) {
        messageData = null;
      }
      if (messageData) {
        switch (messageData.action) {
          case 'VIDEO_STARTED':
            this.onCastVideoStarted();
            break;
          case 'PONG':
            this.onPong();
            break;
          case 'SEND_BG':
            this.sendBgImage();
            break;
          case 'UNLOAD':
            this.onDisconnected();
            break;
          default:
            break;
        }
      }
    }
  }

  onPong() {
    if (!this.firstPingReceived) {
      this.firstPingReceived = true;
      this.onCastConnected();
    }
    setTimeout(() => this.sendPing(), 500);
    clearTimeout(this.disconnectedTimer);
  }
  sendPing() {
    clearTimeout(this.pingTimer);
    this.sendMessage({
      action: 'PING',
    });
    this.pingTimer = setTimeout(() => {
      this.onDisconnected();
    }, 10 * 1000);
  }
  onCastConnected() {
    console.log('CAST DEVICE CONNECTED');
    clearTimeout(this.pingLoopTimer);
    const castSession = window.cast.framework.CastContext.getInstance().getCurrentSession();
    const device = castSession.getCastDevice();
    if (device) {
      this.store.dispatch(appStore.setCastDeviceName(device.friendlyName));
    }
    this.onReceiverReady();
    this.sendPing();
  }
  onConnecting() {
    console.log('CAST DEVICE CONNECTING');
    this.store.dispatch(appStore.setCastState(CAST_STATE.CONNECTING));
  }

  resetFlags() {
    clearTimeout(this.sendPingTimer);
    this.firstPingReceived = false;
    this.lastBgPosition = 0;
    this.castMessageEventBinded = false;
  }

  onDisconnected() {
    console.log('CAST DEVICE NOT CONNECTED');
    this.store.dispatch(appStore.setCastState(CAST_STATE.NOT_CONNECTED));
    this.checkCastStateChange();
    const castSession = window.cast.framework.CastContext.getInstance().getCurrentSession();
    if (castSession) {
      castSession.endSession();
    }
    this.resetFlags();
    this.sendPingInLoop();
  }

  sendPingInLoop() {
    clearTimeout(this.sendPingTimer);
    this.pingLoopTimer = setTimeout(() => {
      this.sendPing();
      this.sendPingInLoop();
    }, 500);
  }

  checkCastStateChange() {
    clearTimeout(this.castStateCheckTimer);
    this.castStateCheckTimer = setTimeout(() => {
      const castState = window.cast.framework.CastContext.getInstance().getCastState();
      if (castState && castState !== this.castState) {
        // console.log("CAST STATE CHANGED", castState);
        this.castState = castState;
        if (castState === 'NOT_CONNECTED') {
          this.disconnectedTimer = window.setTimeout(() => {
            this.onDisconnected();
          }, 500);
        }
      }
      this.checkCastStateChange();
    }, 500);
  }
  initializeCastPlayer() {
    try {
      if (window.chrome?.cast) {
        window.cast.framework.CastContext.getInstance().setOptions({
          receiverApplicationId: this.receiverAppId,
          autoJoinPolicy: window.chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
          language: 'English',
          resumeSavedSession: true,
        });
        this.checkCastStateChange();
        this.sendPingInLoop();
      }
    } catch (err) {
      console.error('initializeCastPlayer', err);
    }
  }
  async sendMessage(data) {
    const castSession = window.cast.framework.CastContext.getInstance().getCurrentSession();
    if (castSession) {
      try {
        await castSession.sendMessage(this.namespace, {
          ...data,
        });
        if (!this.castMessageEventBinded) {
          this.castMessageEventBinded = true;
          castSession.addMessageListener(this.namespace, this.onReceiverMessages.bind(this));
        }
      } catch (err) {
        console.error('sendMessage', err);
      }
    }
  }
  sendSocketMessage(payload) {
    this.sendMessage({
      action: 'SEND_SOCKET_MESSAGE',
      payload,
    });
  }
}

export default CastSender;
